import React from 'react'

import type { TooltipProps } from 'antd'

import { DesignSystemProvider } from '../../theme/Provider'

import { Tooltip as TooltipBase } from './Tooltip'

export const Tooltip: React.FC<TooltipProps> = (props) => (
  <DesignSystemProvider>
    <TooltipBase {...props} />
  </DesignSystemProvider>
)

export type { TooltipProps } from 'antd'
export type { TooltipPlacement } from 'antd/es/tooltip'
